module.exports = __webpack_public_path__ + "static/media/featureProgramming.4caefcbf.png";